import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { HeroSection } from '../components/sections/HeroSection';
import { AboutSection } from '../components/sections/AboutSection';
import { TeamSection } from '../components/sections/TeamSection';
import { ServicesSection } from '../components/sections/ServicesSection';
import { WhyUsSection } from '../components/sections/WhyUsSection';
import { LocationsSection } from '../components/sections/LocationsSection';
import { ResourcesSection } from '../components/sections/ResourcesSection';
import { ContactSection } from '../components/sections/ContactSection';

const HomePage = () => {
  return (
    <div>
      <Header />
      <HeroSection />
      <AboutSection />
      <TeamSection />
      <ServicesSection />
      <WhyUsSection />
      <LocationsSection />
      <ResourcesSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
